import axios from 'axios';

import config from '../configs';
import utils from '../utils';
import services from '../services';

const privyService = {
  getCustomerStatus: async (successCallback, errorCallback) => {
    axios
      .get(config.apiBaseUrl + 'api/julo_privy/v1/customer-status-privy', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getDocumentStatus: async (successCallback, errorCallback) => {
    axios
      .get(config.apiBaseUrl + 'api/julo_privy/v1/document-status', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getDocumentStatusJ1: async (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiBaseUrl +
          'api/julo_privy/v1/document-status-privy/' +
          payload.loan_xid,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  documentUploadJ1: (payload, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl + 'api/julo_privy/v1/document-upload-privy/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  documentUpload: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/julo_privy/v1/document-upload/', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  requestOtp: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/julo_privy/v1/request-otp/', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  requestOtpJ1: (payload, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl + 'api/julo_privy/v1/request-otp-privy/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  confirmOtp: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/julo_privy/v1/confirm-otp/', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  confirmOtpJ1: (payload, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl + 'api/julo_privy/v1/confirm-otp-privy/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  docSignJ1: (payload, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl + 'api/julo_privy/v1/document-sign-privy/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  docSign: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/julo_privy/v1/document-sign/', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  checkMobileFeature: (payload, successCallback, errorCallback) => {
    axios
      .get(
        config.apiBaseUrl +
          'api/v2/mobile/feature-settings?feature_name=' +
          payload.feature,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  signatureUpload: (payload, loan_xid, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl +
          'api/loan/v1/agreement/signature/upload/' +
          loan_xid +
          '/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  imageReUpload: (payload, type, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl +
          'api/julo_privy/v1/upload-image-reupload/' +
          type +
          '/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  reUploadCustomer: async (payload, successCallback, errorCallback) => {
    axios
      .post(
        config.apiBaseUrl + 'api/julo_privy/v1/reupload-privy-customer/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + utils.store.get('token'),
          },
        },
      )
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          payload,
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
};

export default privyService;
